import React, { useContext, useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import TaskPage from "../task-page/task-page";
import { GetColumnDefinitionByCompany } from "../../../../services/api/settings-api";
import { GetRolePrivilege } from "../../../../services/api/role-privilege-api";
import { GetDepartment } from "../../../../services/api/department-api";
import { GetProfile } from "../../../../services/api/profile-api";
import { LoginContext } from "../../../../services/api/authentication-api";
import NoPermissionTable from "../../../../components/no-permission-table/NoPermissionTable";
import { User_Logout } from "../../../../services/auth";
import { TaskMain } from "../telerik-tasks/static-task-list/task-main";
import { ConfigurableTaskMain } from "../telerik-tasks/configurable-task-list/configurable-task-main";
import "./tasks-page.scss";

const initialTaskListType = window?.APP_SETTINGS?.TASK_LIST ?? null;

const TasksPage = () => {
  const userCtx = useContext(LoginContext);
  const companyId = userCtx?.currentUser?.department?.CompanyID
    ?? userCtx?.currentUser?.department?.companyID ?? 0;

  const [privileges, setPrivileges] = useState({});
  const [dateFormatID, setDateFormatID] = useState("en-US");
  const [taskListType, setTaskListType] = useState(initialTaskListType);

  useEffect(() => {
    let isMounted = true;

    (async () => {
      try {
        const user = await GetProfile();
        if (!user) {
          User_Logout();
          return;
        }

        const [department, rolePrivileges] = await Promise.all([
          GetDepartment(user.company),
          GetRolePrivilege(user.role),
        ]);

        if (!isMounted) return;

        const mapped = {};
        if (Array.isArray(rolePrivileges)) {
          for (let i = 0; i < rolePrivileges.length; i++) {
            const p = rolePrivileges[i];
            if (p?.MenuItem) mapped[p.MenuItem] = p;
          }
        }

        setPrivileges(mapped);
        setDateFormatID(department?.dateFormatID === 2 ? "en-US" : "en-GB");
      } catch (err) {
        // Keep original behavior (log but don't crash UI)
        // eslint-disable-next-line no-console
        console.log(err);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    let isMounted = true;

    if (!taskListType && companyId > 0) {
      GetColumnDefinitionByCompany(companyId)
        .then((response) => {
          if (!isMounted) return;
          if (response && response.data) {
            const resolved = response.data;
            if (resolved?.length > 0) {
              setTaskListType("configurable");
            } else {
              setTaskListType("static");
            }
          } else {
            setTaskListType("static");
          }
        })
        .catch((error) => {
          setTaskListType("static");
          // eslint-disable-next-line no-console
          console.log("Error fetching column definition:", error);
        });
    }

    return () => {
      isMounted = false;
    };
  }, [companyId, taskListType]);

  const renderTaskList = () => {
    if (!taskListType) return null;

    const t = taskListType?.toLowerCase();
    if (t === "configurable") return <ConfigurableTaskMain />;
    return <TaskMain />;
  };

  const noTaskManagementView =
    privileges &&
    privileges["Task Management"] &&
    !privileges["Task Management"].View;

  return (
    <Switch>
      <Route exact path="/tasks">
        {noTaskManagementView ? <NoPermissionTable /> : renderTaskList()}
      </Route>

      <Route path="/tasks/">
        <TaskPage privileges={privileges} dateFormatID={dateFormatID} />
      </Route>

      <Route exact path="/">
        <Redirect to="/tasks" />
      </Route>
    </Switch>
  );
};

export default TasksPage;
